import './App.css';

function App() {
  return (
    <div className="App">
      <div class="App-pic">
        <img src="IMG-20241008-WA0003.jpg" className="pic" alt="" />
      </div>
      <header className="App-header">
      <br/>
        <img src="heart.ico" className="App-logo" alt="" />
        <p>
        <br/>
          Nun ist der Adventskalender zu Ende und wir haben Heiligabend. <br/>
          Ich kann mit absoluter Sicherheit sagen, dass dies der aufwendigste Abdventskalender war, den ich je gemacht habe (auch der Einzige, aber das heißt auch was).
          Darauf kannst du dir echt etwas einbilden. Ich finde es hat sich jeder Aufwand gelohnt, sich die persönlichen Rätsel auszudenken und mich gemeinsamen Erinnerungen zu verknüpfen.
          Selbstverständlich war das Highlight am 14.12. Ich hoffe du hast dich gefreut! <br/>
          Ich bin unglaublich froh, dass ich dich in meinem Leben habe und so etwas für DICH machen darf. Ich freue mich immernoch sehr darüber, dass du meinen Ring trägst, 
          der dich immer an meine Liebe zu dir erinnern wird.
          Ich liebe dich dafür, dass ... <br/>
          ... du meine depressiven Episoden erträgst<br/>
          ... du versuchst mich immer wieder aufzubauen<br/>
          ... du dir mit mir zu Hause in Linau etwas gemeinsames schaffen möchtest/geschaffen hast<br/>
          ... ich mit dir über alles reden kann (auch wenn ich es manchmal nicht will)<br/>
          ... du mein Leben facettenreichen machst<br/>
          ... du dich so gut in meine Familie eingefunden hast<br/>
          ... du mich komplett machst<br/>
          ... du immer wieder auf mich eingehst<br/>
          ... du die Katzen mitgebracht hast<br/>
          ... du einfach in meinem Leben bist<br/>
          ... du ehrlich zu mir bist<br/>
          ... du meine direkte Art aktzeptierst<br/>

          Ich wünsche mir noch viele viele gemeinsame Jahre mit dir, in denen wir glücklich zusammen leben und alt werden können.<br/>
          Du bist das Beste was mir je passiert ist!
          <br/><br/>

          Ich liebe dich!<br/>
          Die Lösung für das letzte Türchen ist: 2022
        </p>
      </header>
    </div>
  );
}

export default App;
